import DashboardLayout from "@pma/app/dashboard/layout";
import ProjectsTable from "@components/projects/projects-table";

const ProjectsPage = () => {
  return (
    <DashboardLayout>
      <ProjectsTable />
    </DashboardLayout>
  );
};

export default ProjectsPage;
